import { render, staticRenderFns } from "./CardLegendChart.html?vue&type=template&id=54da8f12&external"
import script from "./CardLegendChart.ts?vue&type=script&lang=ts&external"
export * from "./CardLegendChart.ts?vue&type=script&lang=ts&external"
import style0 from "./CardLegendChart.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports